/**
 * @generated SignedSource<<2963cc4d1f514b19785dc40a9bda8102>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributionsCount"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributionsCursor"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributionsFilters"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contributionsSort"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconClass",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryColor",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryContrastColor",
  "storageKey": null
},
v8 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "contributionsCursor"
  },
  {
    "kind": "Variable",
    "name": "filters",
    "variableName": "contributionsFilters"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "contributionsCount"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "contributionsSort"
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContributionsDatavizListThemePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ContributionsDatavizListTheme_theme"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContributionsDatavizListThemePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ParticipativeModule",
                "kind": "LinkedField",
                "name": "participativeModule",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "visualization",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "enableListViewOnFirstPage",
                            "storageKey": null
                          }
                        ],
                        "type": "ContributionsDataviz",
                        "abstractKey": null
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ParticipativeModuleAuthorizations",
                    "kind": "LinkedField",
                    "name": "authorizations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bookmarksCreationAuthorized",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "themes",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "concreteType": "ContributionConnection",
                "kind": "LinkedField",
                "name": "contributions",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContributionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Contribution",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isMine",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isBookmarked",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "themes",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "token",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "title",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isFromAdminUser",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Author",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "avatarUrl",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "statusName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isAdmin",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "additionalViewerFields",
                                    "storageKey": null
                                  }
                                ],
                                "type": "Viewer",
                                "abstractKey": "__isViewer"
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ParticipativeModule",
                            "kind": "LinkedField",
                            "name": "participativeModule",
                            "plural": false,
                            "selections": [
                              (v4/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Theme",
                            "kind": "LinkedField",
                            "name": "theme",
                            "plural": false,
                            "selections": [
                              (v5/*: any*/),
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v9/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Theme",
                                "kind": "LinkedField",
                                "name": "parent",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Theme",
                                    "kind": "LinkedField",
                                    "name": "parent",
                                    "plural": false,
                                    "selections": [
                                      (v5/*: any*/),
                                      (v6/*: any*/),
                                      (v7/*: any*/),
                                      (v9/*: any*/),
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v3/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "totalCommentsCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "votesMode",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "authorizations",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "votesDisplayAuthorized",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "votesDownAuthorized",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "commentsDisplayAuthorized",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Votes",
                                "kind": "LinkedField",
                                "name": "votes",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "up",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "down",
                                    "storageKey": null
                                  },
                                  (v3/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "type": "Reactable",
                            "abstractKey": "__isReactable"
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "totalCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v8/*: any*/),
                "filters": [
                  "filters",
                  "sort"
                ],
                "handle": "connection",
                "key": "ContributionsList_contributions",
                "kind": "LinkedHandle",
                "name": "contributions"
              },
              (v9/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  (v3/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Theme",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v9/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Theme",
                    "kind": "LinkedField",
                    "name": "parent",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Theme",
                        "kind": "LinkedField",
                        "name": "parent",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contributionsCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reactionsCount",
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "type": "Theme",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0eb985ff9ca7c780c5be201ca8dee04e",
    "id": null,
    "metadata": {},
    "name": "ContributionsDatavizListThemePaginationQuery",
    "operationKind": "query",
    "text": "query ContributionsDatavizListThemePaginationQuery(\n  $contributionsCount: Int\n  $contributionsCursor: String\n  $contributionsFilters: ContributionsListFiltersInput\n  $contributionsSort: ContributionsSortInput\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ContributionsDatavizListTheme_theme\n    id\n  }\n}\n\nfragment BookmarkedFilter_participativeModule on ParticipativeModule {\n  authorizations {\n    bookmarksCreationAuthorized\n  }\n}\n\nfragment ContributionCardThemes_contribution on Contribution {\n  theme {\n    iconClass\n    primaryColor\n    primaryContrastColor\n    name\n    parent {\n      iconClass\n      primaryColor\n      primaryContrastColor\n      name\n      parent {\n        iconClass\n        primaryColor\n        primaryContrastColor\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment ContributionCardThemes_theme on Theme {\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n  parent {\n    name\n    primaryColor\n    primaryContrastColor\n    id\n  }\n}\n\nfragment ContributionsDatavizFilters_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizViewerFilters_participativeModule\n}\n\nfragment ContributionsDatavizListThemeContribution_contribution on Contribution {\n  slug\n  token\n  title\n  themes {\n    id\n    name\n  }\n  isFromAdminUser\n  author {\n    ...UserAvatar_user\n    ...UserAuthorName_user\n    id\n  }\n  participativeModule {\n    slug\n    id\n  }\n  ...ContributionCardThemes_contribution\n  ...ReactableMeasures_reactable\n}\n\nfragment ContributionsDatavizListThemeContribution_theme on Theme {\n  slug\n  ...ContributionCardThemes_theme\n}\n\nfragment ContributionsDatavizListTheme_theme on Theme {\n  participativeModule {\n    ...ContributionsDatavizMainContainerHeader_participativeModule\n    id\n  }\n  contributions(first: $contributionsCount, after: $contributionsCursor, filters: $contributionsFilters, sort: $contributionsSort) {\n    edges {\n      node {\n        id\n        isMine\n        isBookmarked\n        themes {\n          id\n        }\n        ...ContributionsDatavizListThemeContribution_contribution\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  ...ContributionsDatavizThemeLayout_theme\n  ...ContributionsDatavizListThemeContribution_theme\n  ...ContributionsDatavizMainContainerHeader_theme\n  id\n}\n\nfragment ContributionsDatavizMainContainerHeader_participativeModule on ParticipativeModule {\n  ...ContributionsDatavizViewModeSwitch_participativeModule\n}\n\nfragment ContributionsDatavizMainContainerHeader_theme on Theme {\n  ...ContributionsDatavizViewModeSwitch_theme\n}\n\nfragment ContributionsDatavizSearchFiltersThemes_themes on Theme {\n  id\n  name\n  primaryColor\n  primaryContrastColor\n  iconClass\n  parent {\n    id\n    parent {\n      id\n    }\n  }\n}\n\nfragment ContributionsDatavizTabs_participativeModule on ParticipativeModule {\n  slug\n  visualization {\n    __typename\n    ... on ContributionsDataviz {\n      enableListViewOnFirstPage\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizThemeLayout_theme on Theme {\n  participativeModule {\n    slug\n    ...ContributionsDatavizTabs_participativeModule\n    id\n  }\n  ...ContributionsDatavizThemeViewSidebar_theme\n  ...ContributionsDatavizViewModeSwitch_theme\n}\n\nfragment ContributionsDatavizThemeMeasures_theme on Theme {\n  contributionsCount\n  reactionsCount\n}\n\nfragment ContributionsDatavizThemeViewSidebar_theme on Theme {\n  name\n  iconClass\n  primaryColor\n  primaryContrastColor\n  parent {\n    name\n    id\n  }\n  children {\n    ...ContributionsDatavizSearchFiltersThemes_themes\n    id\n  }\n  participativeModule {\n    slug\n    ...ContributionsDatavizFilters_participativeModule\n    id\n  }\n  ...ContributionsDatavizThemeMeasures_theme\n  ...ContributionsDatavizThemesCarousel_currentTheme\n}\n\nfragment ContributionsDatavizThemesCarousel_currentTheme on Theme {\n  id\n  participativeModule {\n    slug\n    themes {\n      id\n      slug\n      iconClass\n      primaryColor\n      primaryContrastColor\n      children {\n        id\n        slug\n        iconClass\n        primaryColor\n        primaryContrastColor\n      }\n    }\n    id\n  }\n}\n\nfragment ContributionsDatavizViewModeSwitch_participativeModule on ParticipativeModule {\n  slug\n}\n\nfragment ContributionsDatavizViewModeSwitch_theme on Theme {\n  slug\n}\n\nfragment ContributionsDatavizViewerFilters_participativeModule on ParticipativeModule {\n  ...BookmarkedFilter_participativeModule\n}\n\nfragment ReactableMeasures_reactable on Reactable {\n  __isReactable: __typename\n  totalCommentsCount\n  votesMode\n  authorizations {\n    __typename\n    votesDisplayAuthorized\n    votesDownAuthorized\n    commentsDisplayAuthorized\n    id\n  }\n  votes {\n    up\n    down\n    id\n  }\n}\n\nfragment UserAuthorName_user on Viewer {\n  __isViewer: __typename\n  name\n  statusName\n  isAdmin\n  additionalViewerFields\n}\n\nfragment UserAvatar_user on Viewer {\n  __isViewer: __typename\n  name\n  avatarUrl\n}\n"
  }
};
})();

node.hash = "0c2baa2e2e7a3dec8f28ea18000704a6";

module.exports = node;
